module.exports = __webpack_public_path__ + "static/media/27.e3d03616.jpg";